import React, { useState, useEffect, useCallback } from 'react';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Dialog from '@mui/material/Dialog';
import Typography from '@mui/material/Typography';
import DatePicker from '../../../DatePicker';

const CreateNotificationDialog = ({ onHide, onConfirm }) => {
    const [subject, setSubject] = useState('');
    const [body, setBody] = useState('');
    const [linkUrl, setLinkUrl] = useState('');
    const [linkText, setLinkText] = useState('');
    const [date, setDate] = useState(null);
    const [isValid, setIsValid] = useState(false);
    const [form, setForm] = useState(null);

    const onRefChange = useCallback(node => setForm(node), []);

    const handleSubmit = e => {
        e.preventDefault();
        onConfirm({ date, subject, body, linkText, linkUrl });
    };

    useEffect(() => {
        setIsValid(form && form.checkValidity());
    }, [form, subject, body]);

    return (
        <Dialog onClose={onHide} open={true}>
            <form ref={onRefChange} onSubmit={handleSubmit}>
                <DialogTitle>New Announcement</DialogTitle>
                <DialogContent dividers>
                    <Typography sx={{ pb: 3 }}>
                        Create a NewZapp announcement.
                    </Typography>
                    <DatePicker
                        id="date"
                        label="Date"
                        fullWidth={true}
                        value={date}
                        required
                        onChange={setDate}
                    />
                    <TextField
                        autoFocus
                        id="subject"
                        label="Subject"
                        type="text"
                        size="small"
                        fullWidth
                        value={subject}
                        required
                        onChange={e => setSubject(e.target.value)}
                    />
                    <TextField
                        id="body"
                        label="Body"
                        type="text"
                        fullWidth
                        size="small"
                        value={body}
                        required
                        onChange={e => setBody(e.target.value)}
                    />
                    <TextField
                        id="linkUrl"
                        label="LinkText"
                        type="text"
                        fullWidth
                        size="small"
                        value={linkText}
                        onChange={e => setLinkText(e.target.value)}
                    />
                    <TextField
                        id="linkUrl"
                        label="LinkUrl"
                        type="text"
                        fullWidth
                        size="small"
                        value={linkUrl}
                        onChange={e => setLinkUrl(e.target.value)}
                    />
                </DialogContent>
                <DialogActions>
                    <Button type="submit" disabled={!isValid}>Create Notification</Button>
                    <Button variant="outlined" onClick={onHide}>Cancel</Button>
                </DialogActions>
            </form>
        </Dialog>
    );
};

export default CreateNotificationDialog;